export default __webpack_public_path__ + "static/media/user-white.ae3514e1.svg";